<template>
  <div class="empty-state">
    <img v-lazy="'/static/images/empty.svg'" alt="empty image" />
    <h3 v-if="title">{{ title }}</h3>
    <p v-if="description" v-html="description"></p>
  </div>
</template>

<script>
export default {
  props: ['title', 'description']
};
</script>

<style lang="scss" scoped>
.empty-state {
  text-align: center;
  padding: 16px;
  margin: 0 auto;

  h3 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    margin-top: 0;
    color: black;
  }
  img {
    width: 119px;
    height: 116px;
    margin: 20px 0;
  }
}
p {
  line-height: 24px;
}
</style>
